import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { RptFillAlllDDlserviceService } from 'src/app/Shared/Services/rpt-fill-alll-ddlservice.service';
import { ToastrService } from 'ngx-toastr';

declare var $: any;
@Component({
  selector: 'app-rpt-bidding',
  templateUrl: './rpt-bidding.component.html',
  styleUrls: ['./rpt-bidding.component.css']
})
export class RptBiddingComponent implements OnInit {

  FrmRptBidding: FormGroup; loginlist: any = [];
  ddlAuctionNoList: any = []; _filterAuctionList: any = [];
  AuctionFromToRowVisible: Boolean;
  DateFromToRowVisible: Boolean;AuctionNoRowVisible: Boolean;
  FromDate: any; ToDate: any;

  constructor(private fb: FormBuilder, private MsgService: ToastrService, private router: Router,
    private RptFillAlllDDlService: RptFillAlllDDlserviceService) {
    this.CreateFrmRptAuction();
   
   // this.AuctionFromToRowVisible = true;
  }
  ngOnInit() {
    this.FillAllDDL();
    this.DateFromToRowVisible = true;
    this.AuctionNoRowVisible = false;
  }
  CreateFrmRptAuction() {
    this.FrmRptBidding = this.fb.group({

      ddlAuctionNo: [''],
      ddlSearchingType: ['1'],
      txtDateFrom: ['', [Validators.maxLength(10), Validators.minLength(10)]],
      txtDateTo: ['', [Validators.maxLength(10), Validators.minLength(10)]],
      txtAuctionNoFrom: [''],
      txtAuctionNoTo: [''],
    })
  }

  FillAllDDL() {
    let Ind = 1;
    let ResponseDecrpt = sessionStorage.getItem('loginSession');
    let loginlist = JSON.parse(window.atob(ResponseDecrpt));
    let OrgCode = loginlist[0]['OrgCode'];
    let CityCode = loginlist[0]['CityCode'];
    this.RptFillAlllDDlService.FillAllddl(Ind, OrgCode, CityCode).subscribe(respdata => {
     
      if (respdata != "" && respdata.SuccessCD == 1) {
        if (respdata.RespData.Table.length > 0) {

          this.ddlAuctionNoList = respdata.RespData.Table8
          this._filterAuctionList = this.ddlAuctionNoList.slice();
        }
      }
      else {
        if (respdata != "" && respdata.SuccessCD == 0) {
          this.MsgService.warning(respdata.MsgDesc);
        }
        else { this.MsgService.error('Not Found'); }
      }
    })
  }

  OnBiddingPreview() {
    let AuctionNo = this.FrmRptBidding.controls['ddlAuctionNo'].value;
    if (AuctionNo == "") {
      AuctionNo = "0";
    }

    let ResponseDecrpt = sessionStorage.getItem('loginSession');
    this.loginlist = JSON.parse(window.atob(ResponseDecrpt));

    let OrgCode = this.loginlist[0]['OrgCode'];
    let CityCode = this.loginlist[0]['CityCode'];
    let Heading = this.loginlist[0]['ReportHeading'];    
    this.FromDate = this.FrmRptBidding.controls['txtDateFrom'].value;
    this.ToDate = this.FrmRptBidding.controls['txtDateTo'].value;

    let AuctionNoFrom = this.FrmRptBidding.controls['txtAuctionNoFrom'].value;
    let AuctionNoTo = this.FrmRptBidding.controls['txtAuctionNoTo'].value;

   
    let a = this.FrmRptBidding.controls['ddlSearchingType'].value;
   let DateInd = a ;
    if (a == 1 || a == 3) {
     // this.FrmRptBidding.controls['txtAuctionNoFrom'].setValue('0');
      //this.FrmRptBidding.controls['txtAuctionNoTo'].setValue('0');
      if (this.FromDate == '') {
        {
          this.MsgService.error("Please select the from Date");
          return false;
        }
      }
      if (this.ToDate == '') {
        {
          this.MsgService.error("Please select the To Date ");
          return false;
        }
      }
      if (this.FromDate != '' && this.ToDate != '') {
        if (this.FrmRptBidding.controls['txtDateFrom'].value > this.FrmRptBidding.controls['txtDateTo'].value) {
          this.MsgService.error("From Date cannot be  greater than  To ");
          return false;
        }
      }
      var res = $('#txtDateFr').val().split('/');
      this.FromDate = res[2] + '/' + res[1] + '/' + res[0];
  
      var restodt = $('#txtDateToo').val().split('/');
      this.ToDate = restodt[2] + '/' + restodt[1] + '/' + restodt[0];
    }
    if (a == 2) {   

      this.FrmRptBidding.controls['txtDateFrom'].setValue('');
      this.FrmRptBidding.controls['txtDateTo'].setValue('');

      if (AuctionNoFrom == '' || AuctionNoFrom == '0' ) {
        {
          this.MsgService.error("Please Enter Auction no from ");
          return false;
        }
      }
    
      if (AuctionNoTo == '' || AuctionNoTo == '0' ) {
        {
          this.MsgService.error("Please Enter Auction no To ");
          return false;
        }
      }
    
    if (AuctionNoFrom> AuctionNoTo) {
      {
        this.MsgService.error("Auction No from cannot be greater then Auction To");
        return false;
      }
    }
    
  }

    // var frmdt = $('#txtDateFr').val();

    // var res = frmdt.split('/');
    // this.FromDate = res[2] + '/' + res[1] + '/' + res[0];

// if(this.FrmRptBidding.controls['txtAuctionNoFrom'].value=='')
// {
//   this.FrmRptBidding.controls['txtAuctionNoFrom'].setValue('0');
// }
// if(this.FrmRptBidding.controls['txtAuctionNoTo'].value=='')
// {
//   this.FrmRptBidding.controls['txtAuctionNoTo'].setValue('0');
// }
    let ReportHeading = 'Bidding Master Report';

     //window.open(`http://localhost:50675/RptBidding.aspx?Ind=1&OrgCode=` + OrgCode + `&CityCode=` + CityCode + `&AuctionNo=` + AuctionNo + `&DateFrom=` + this.FromDate + `&DateTo=` + this.ToDate + `&AuctionNoFrom=` + AuctionNoFrom + `&AuctionNoTo=` + AuctionNoTo + `&DateInd=`+ DateInd + `&ReportHeading=` + ReportHeading + `&Heading=` + Heading + `&ReportName=RptBidding`);
    //window.open(`http://115.124.113.64/JMCEAuctionReportSource/RptBidding.aspx?Ind=1&OrgCode=` + OrgCode + `&CityCode=` + CityCode + `&AuctionNo=` + AuctionNo + `&AuctionTypecd=` + AuctionType + `&ActiveInd=` + Status + `&Zone=` + Zone + `&DateFrom=` + this.FromDate + `&DateTo=` + this.ToDate + `&ReportHeading=` + ReportHeading + `&Heading=` + Heading + `&ReportName=RptAuction`);
    //window.open(`http://oswalapp.centralindia.cloudapp.azure.com/JMCEAuctionReportViewerSource/RptBidding.aspx?Ind=1&OrgCode=` + OrgCode + `&CityCode=` + CityCode + `&AuctionNo=` + AuctionNo + `&DateFrom=` + this.FromDate + `&DateTo=` + this.ToDate + `&ReportHeading=` + ReportHeading + `&Heading=` + Heading + `&ReportName=RptAuction`);
  //  window.open(`http://oswalapp.centralindia.cloudapp.azure.com/JMCEAuctionReportViewerSource//RptBidding.aspx?Ind=1&OrgCode=` + OrgCode + `&CityCode=` + CityCode + `&AuctionNo=` + AuctionNo + `&DateFrom=` + this.FromDate + `&DateTo=` + this.ToDate + `&ReportHeading=` + ReportHeading + `&Heading=` + Heading + `&ReportName=RptBidding`);
  window.open(`http://oswalapp.centralindia.cloudapp.azure.com/BMCEAuctionReportViewerSource/RptBidding.aspx?Ind=1&OrgCode=` + OrgCode + `&CityCode=` + CityCode + `&AuctionNo=` + AuctionNo + `&DateFrom=` + this.FromDate + `&DateTo=` + this.ToDate + `&AuctionNoFrom=` + AuctionNoFrom + `&AuctionNoTo=` + AuctionNoTo + `&DateInd=`+ DateInd + `&ReportHeading=` + ReportHeading + `&Heading=` + Heading + `&ReportName=RptBidding`);
    
  }

  OnClear() {

    this.FrmRptBidding.controls['ddlAuctionNo'].setValue('');

    this.FrmRptBidding.controls['txtDateFrom'].setValue('');
    this.FrmRptBidding.controls['txtDateTo'].setValue('');
    this.FrmRptBidding.controls['txtAuctionNoFrom'].setValue('');
    this.FrmRptBidding.controls['txtAuctionNoTo'].setValue('');

  }
  OnSearchReportType(event) {
   
    let a = event.value;
    if (a == 1 || a==3) {
      this.DateFromToRowVisible = true;
      this.AuctionFromToRowVisible = false;
      this.FrmRptBidding.controls['txtAuctionNoFrom'].setValue('');
      this.FrmRptBidding.controls['txtAuctionNoTo'].setValue('');

    }
    else if (a == 2) {
      this.DateFromToRowVisible = false;
      this.AuctionFromToRowVisible = true;
      this.FrmRptBidding.controls['txtDateFrom'].setValue('');
      this.FrmRptBidding.controls['txtDateTo'].setValue('');

    }


  }
  onAuctionChange(name: string) {
    this._filterAuctionList = this._myFilter(name);

  }
  private _myFilter(name: string): any[] {
    if (name) {
      return this.ddlAuctionNoList
        .filter(group => group.AuctionNo.toLowerCase().includes(name.toLowerCase()));
    }
    return this.ddlAuctionNoList;
  }
}